/**
 * Combine all reducers in this file and export the combined reducers.
 * If we were to do this in store.ts, reducers wouldn't be hot reloadable.
 */

import { combineReducers, type Reducer } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { reducer as authentication } from './authentication';
import { reducer as booking } from './booking';
import { reducer as casting } from './casting';
import { reducer as colorPalette } from './colorPalette';
import { reducer as discoveryPlaylist } from './discoveryPlaylist';
import { reducer as featureFlags } from './featureFlags';
import type { FeatureFlagsState } from './featureFlags/types';
import { reducer as language } from './language';
import type { LanguageState } from './language/types';
import { reducer as layout } from './layout';
import { reducer as lights } from './light';
import { reducer as player } from './player';
import { reducer as room } from './room';
import type { RoomState } from './room/types';
import { reducer as search } from './search';
import { reducer as serviceWorker } from './serviceWorker';
import { reducer as session } from './session';
import type { SessionState } from './session/types';
import { reducer as songStorage } from './songStorage';
import type { SongStorageState } from './songStorage/types';
import { reducer as subscription } from './subscription';
import type { RootState } from './types';
import { reducer as user } from './user';
import type { UserState } from './user/types';
import { reducer as videoPlayerResources } from './videoPlayerResources';
import { reducer as game } from './game';
import { reducer as blindTest } from './blindTest';

export const PLAYER = 'player';
const SESSION = 'session';
const ROOM = 'room';
const USER = 'user';
const SONGSTORAGE = 'songStorage';

const FEATUREFLAGS = 'featureFlags';
const LANGUAGE = 'language';

const roomPersistConfig = {
  key: ROOM,
  storage,
};

const sessionPersistConfig = {
  key: SESSION,
  storage,
};

const userPersistConfig = {
  key: USER,
  storage,
};

const songStoragePersistConfig = {
  key: SONGSTORAGE,
  storage,
};

const featureFlagsConfig = {
  key: FEATUREFLAGS,
  storage,
};

const languageConfig = {
  key: LANGUAGE,
  storage,
};

const rootReducer = combineReducers<RootState>({
  authentication,
  booking,
  casting,
  layout,
  [PLAYER]: player,
  search,
  subscription,
  colorPalette,
  [SESSION]: persistReducer(sessionPersistConfig, session) as unknown as Reducer<SessionState>,
  [ROOM]: persistReducer(roomPersistConfig, room) as unknown as Reducer<RoomState>,
  [LANGUAGE]: persistReducer(languageConfig, language) as unknown as Reducer<LanguageState>,
  [USER]: persistReducer(userPersistConfig, user) as unknown as Reducer<UserState>,
  serviceWorker,
  discoveryPlaylist,
  videoPlayerResources,

  [SONGSTORAGE]: persistReducer(
    songStoragePersistConfig,
    songStorage,
  ) as unknown as Reducer<SongStorageState>,
  [FEATUREFLAGS]: persistReducer(
    featureFlagsConfig,
    featureFlags,
  ) as unknown as Reducer<FeatureFlagsState>,
  lights,
  game,
  blindTest,
});

export default rootReducer;
